export default __webpack_public_path__ + "static/media/008-tools.6b5c7466.png";